// extracted by mini-css-extract-plugin
export var slide = "advsSwiper-module--slide--zrXy9";
export var swiper = "advsSwiper-module--swiper--8ExSF";